import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const practiceExtrasService = {
  // Outcomes
  addOutcome: (data) => api.post('/outcomes', data).then((r) => r.data),
  listOutcomes: () => api.get('/outcomes').then((r) => r.data),
  listOutcomesByPatient: (patientId) =>
    api.get(`/outcomes/patient/${patientId}`).then((r) => r.data),

  // Psychiatry
  createPsychEval: (data) => api.post('/psychiatry-evals', data).then((r) => r.data),
  listPsychEvals: (patientId) =>
    api.get(`/psychiatry-evals/patient/${patientId}`).then((r) => r.data),
  signPsychEval: (id) => api.post(`/psychiatry-evals/${id}/sign`).then((r) => r.data),

  // Medications
  addMedication: (data) => api.post('/medications', data).then((r) => r.data),
  listMedications: (patientId) =>
    api.get(`/medications/patient/${patientId}`).then((r) => r.data),
  updateMedication: (id, data) => api.patch(`/medications/${id}`, data).then((r) => r.data),

  // Care groups
  createCareGroup: (data) => api.post('/care-groups', data).then((r) => r.data),
  listCareGroups: () => api.get('/care-groups').then((r) => r.data),

  // Invoices
  createInvoice: (data) => api.post('/invoices', data).then((r) => r.data),
  listInvoices: (patientId) =>
    api.get('/invoices', { params: patientId ? { patientId } : {} }).then((r) => r.data),
  updateInvoice: (id, data) => api.patch(`/invoices/${id}`, data).then((r) => r.data),
  payInvoice: (id, data) => api.post(`/invoices/${id}/payments`, data).then((r) => r.data),
  writeOffInvoice: (id, data) => api.post(`/invoices/${id}/write-off`, data).then((r) => r.data),
  batchInvoicesFromAppointments: (data) =>
    api.post('/invoices/batch-from-appointments', data || {}).then((r) => r.data),
  createPayLink: (id) => api.post(`/invoices/${id}/pay-link`).then((r) => r.data),
  confirmCheckout: (sessionId) =>
    api.post('/invoices/confirm-checkout', { sessionId }).then((r) => r.data),
  getStatement: (patientId) =>
    api.get(`/statements/patient/${patientId}`).then((r) => r.data),

  // Ledger / overview
  getLedger: (patientId) => api.get(`/ledger/patient/${patientId}`).then((r) => r.data),
  addLedgerEntry: (data) => api.post('/ledger', data).then((r) => r.data),
  billingOverview: () => api.get('/billing/overview').then((r) => r.data),

  // Insurers
  createInsurer: (data) => api.post('/insurers', data).then((r) => r.data),
  listInsurers: () => api.get('/insurers').then((r) => r.data),
  updateInsurer: (id, data) => api.patch(`/insurers/${id}`, data).then((r) => r.data),

  // Labs
  createLab: (data) => api.post('/labs', data).then((r) => r.data),
  listLabs: (patientId) => api.get(`/labs/patient/${patientId}`).then((r) => r.data),
  updateLab: (id, data) => api.patch(`/labs/${id}`, data).then((r) => r.data),

  // Claims
  createClaim: (data) => api.post('/claims', data).then((r) => r.data),
  listClaims: (status) =>
    api.get('/claims', { params: status ? { status } : {} }).then((r) => r.data),
  updateClaim: (id, data) => api.patch(`/claims/${id}`, data).then((r) => r.data),
  getClaimCms1500: (id) => api.get(`/claims/${id}/cms1500`).then((r) => r.data),

  // Scribe
  createScribeDraft: (data) => api.post('/scribe-drafts', data).then((r) => r.data),
  listScribeDrafts: (patientId) =>
    api.get(`/scribe-drafts/patient/${patientId}`).then((r) => r.data),
  promoteScribe: (id) => api.post(`/scribe-drafts/${id}/promote`).then((r) => r.data),

  // Waitlist
  addWaitlist: (data) => api.post('/waitlist', data).then((r) => r.data),
  listWaitlist: () => api.get('/waitlist').then((r) => r.data),
  updateWaitlist: (id, data) => api.patch(`/waitlist/${id}`, data).then((r) => r.data),

  // Export
  exportPatient: (patientId) => api.get(`/exports/patient/${patientId}`).then((r) => r.data),
};

export default practiceExtrasService;
